import{jsxs as o,jsx as e}from"react/jsx-runtime";import t from"styled-components";import{useTranslation as i}from"react-i18next";import r from"../../../../../assets/profileSettingsWhatsApp/android/arrow-back-icon.svg.js";import s from"../../../../../assets/profileSettingsWhatsApp/android/more-icon.svg.js";import n from"../../../../../assets/profileSettingsWhatsApp/image-placeholder.svg.js";const a=t.div`
  position: relative;
  background-color: #ccd0d6;
`,p=t.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 2.5px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
`,d=t.div`
  display: flex;
  position: absolute;
  bottom: 0%;
  width: 100%;
  justify-content: space-between;
  padding: 2.5px;
  box-sizing: border-box;
  padding: 20px;
  align-items: center;
`,l=t.div`
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
`,c=t.div`
  max-width: 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
`,h=t.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`,m=({whatsappData:{values:t,placeholders:m}={values:{},placeholders:{}}})=>{const{t:g}=i(),f=`${t.countryCode?`+${t.countryCode}`:""} ${t.phone||m.phone||""}`,w=t.name||m.name;return o(a,{children:[o(p,{children:[e("img",{alt:g("imgAlt.androidArrowBackIcon"),src:r}),e("img",{alt:g("imgAlt.androidMoreIcon"),src:s})]}),o(d,{children:[e(l,{children:f||""}),e(c,{children:w?`~${w}`:""})]}),t.photoUrl?e(h,{alt:g("imgAlt.businessAvatar"),src:t.photoUrl}):e("img",{alt:g("imgAlt.businessAvatarPlaceholder"),src:n})]})};export{m as ProfileImage};
//# sourceMappingURL=ProfileImage.js.map
